import { defineComponent, ref, onMounted, createElementBlock, openBlock, Fragment, renderList, createBlock, createCommentVNode, createElementVNode, resolveDynamicComponent, withCtx, createTextVNode, toDisplayString, createVNode, mergeProps, withModifiers, unref } from 'vue';
import _sfc_main$4 from './basler-components.es79.js';
/* empty css                       */
import _sfc_main$3 from './basler-components.es121.js';
import _sfc_main$1 from './basler-components.es85.js';
/* empty css                       */
import _sfc_main$2 from './basler-components.es64.js';
/* empty css                       */
import _sfc_main$6 from './basler-components.es70.js';
import _sfc_main$5 from './basler-components.es87.js';
/* empty css                       */

const _hoisted_1 = { class: "download-list" };
const _hoisted_2 = {
  key: 2,
  class: "download-list__alert"
};
const _hoisted_3 = { class: "download-list__list" };
const _hoisted_4 = ["data-item-id", "onClick"];
const _hoisted_5 = { class: "download-list__details" };
const _hoisted_6 = ["onClick"];
const _hoisted_7 = {
  key: 2,
  class: "download-list__copied"
};
const _hoisted_8 = {
  key: 3,
  class: "download-list__show-more"
};
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "DownloadList",
  props: {
    groups: {},
    isLoading: { type: Boolean, default: false },
    metaLoadingLines: { default: 3 },
    copyText: { default: "Copy Download Link" },
    copiedText: { default: "Copied to clipboard" },
    headlineLevel: { default: 3 }
  },
  emits: ["open", "more", "share-link-click"],
  setup(__props, { emit: __emit }) {
    const emit = __emit;
    let shareApiAvailable = ref(false);
    const isCopiedId = ref("");
    const copyValueToClipboard = async (id, value) => {
      let timer;
      try {
        clearTimeout(timer);
        await navigator.clipboard.writeText(value);
        isCopiedId.value = id;
        timer = setTimeout(() => {
          isCopiedId.value = "";
        }, 5e3);
      } catch (err) {
        console.log("Clipboard error:", err);
      }
    };
    function shareLink(id, title, url) {
      emit("share-link-click", { id, title, url });
      if (typeof window !== "undefined" && navigator.share) {
        navigator.share({
          title,
          url
        }).then(() => {
          console.log("Thanks for sharing!");
        }).catch(console.error);
      } else {
        copyValueToClipboard(id, url);
      }
    }
    onMounted(() => {
      if (typeof window !== "undefined" && "navigator" in window) {
        shareApiAvailable.value = "share" in navigator;
      }
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1, [
        (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.groups, (group, groupIndex) => {
          return openBlock(), createElementBlock("div", {
            key: groupIndex,
            class: "download-list__group"
          }, [
            _ctx.isLoading && group.title ? (openBlock(), createBlock(_sfc_main$1, {
              key: 0,
              class: "download-list__loading-group-title"
            })) : !_ctx.isLoading && group.title ? (openBlock(), createBlock(resolveDynamicComponent(`h${_ctx.headlineLevel}`), {
              key: 1,
              class: "download-list__group-title"
            }, {
              default: withCtx(() => [
                createTextVNode(toDisplayString(group.title), 1)
              ]),
              _: 2
            }, 1024)) : createCommentVNode("", true),
            !_ctx.isLoading && group.alertBox ? (openBlock(), createElementBlock("div", _hoisted_2, [
              createVNode(_sfc_main$2, mergeProps({ ref_for: true }, group.alertBox), null, 16)
            ])) : createCommentVNode("", true),
            createElementVNode("ul", _hoisted_3, [
              (openBlock(true), createElementBlock(Fragment, null, renderList(group.items, (item, index) => {
                return openBlock(), createElementBlock("li", mergeProps({
                  key: index,
                  "data-item-id": item.id,
                  class: "download-list__item",
                  onClick: ($event) => item.isModal ? emit("open", item.id) : false,
                  ref_for: true
                }, item.downloadListDataAttributes ?? void 0), [
                  _ctx.isLoading ? (openBlock(), createBlock(_sfc_main$1, {
                    key: 0,
                    class: "download-list__loading-title"
                  })) : (openBlock(), createBlock(_sfc_main$3, mergeProps({
                    key: 1,
                    ref_for: true
                  }, item.isModal ? null : item.link || null, { class: "download-list__title" }), {
                    default: withCtx(() => [
                      createVNode(_sfc_main$4, {
                        name: item.iconName ? item.iconName : "download",
                        class: "download-list__icon"
                      }, null, 8, ["name"]),
                      (openBlock(), createBlock(resolveDynamicComponent(`h${_ctx.headlineLevel + 1}`), null, {
                        default: withCtx(() => [
                          createTextVNode(toDisplayString(item.title), 1)
                        ]),
                        _: 2
                      }, 1024))
                    ]),
                    _: 2
                  }, 1040)),
                  createElementVNode("div", _hoisted_5, [
                    item.meta ? (openBlock(), createBlock(_sfc_main$5, {
                      key: 0,
                      items: item.meta,
                      isLoading: _ctx.isLoading,
                      "loading-lines": _ctx.metaLoadingLines
                    }, null, 8, ["items", "isLoading", "loading-lines"])) : createCommentVNode("", true),
                    !_ctx.isLoading && isCopiedId.value !== item.id && (item.linkToShare || item.link && item.link.uri) ? (openBlock(), createElementBlock("button", {
                      key: 1,
                      type: "button",
                      onClick: withModifiers(($event) => shareLink(item.id, item.title, item.linkToShare || item.link?.uri), ["stop"]),
                      class: "download-list__share"
                    }, [
                      createVNode(_sfc_main$4, {
                        name: "share",
                        class: "download-list__share-icon"
                      }),
                      createTextVNode(toDisplayString(unref(shareApiAvailable) ? item.shareText : _ctx.copyText), 1)
                    ], 8, _hoisted_6)) : !_ctx.isLoading && isCopiedId.value === item.id ? (openBlock(), createElementBlock("span", _hoisted_7, [
                      createVNode(_sfc_main$4, {
                        name: "check",
                        class: "download-list__share-icon"
                      }),
                      createTextVNode(toDisplayString(_ctx.copiedText), 1)
                    ])) : createCommentVNode("", true)
                  ])
                ], 16, _hoisted_4);
              }), 128))
            ]),
            group.showMoreButtonText != null && group.showMoreButtonText != "" ? (openBlock(), createElementBlock("div", _hoisted_8, [
              createVNode(_sfc_main$6, {
                "icon-type": "icon-left",
                "icon-name": "arrow-down",
                "style-type": "link",
                onClick: ($event) => emit("more", groupIndex)
              }, {
                default: withCtx(() => [
                  createTextVNode(toDisplayString(group.showMoreButtonText), 1)
                ]),
                _: 2
              }, 1032, ["onClick"])
            ])) : createCommentVNode("", true)
          ]);
        }), 128))
      ]);
    };
  }
});

export { _sfc_main as default };
